import { defineSong } from '../types';

export default defineSong({
  id: 'endulus',
  title: 'Endülüs Rüzgârı',
  level: 2,
  key: 'Am',
  bpm: 108,
  beats: 4,
  pattern: 'D-DU-UDU',
  style: 'Flamenko',
  desc: 'Basamak basamak inen Endülüs kadansı: i–VII–VI–V.',
  sections: [
    { name: 'Giriş', bars: ['Am', 'G', 'F', 'E'] },
    { name: 'Kıta', bars: ['Am', 'G', 'F', 'E', 'Am', 'G', 'F', 'E'] },
    { name: 'Köprü', bars: ['Dm', 'Am', 'Dm', 'E'] },
    { name: 'Nakarat', bars: ['Am', 'G', 'F', 'E', 'F', 'F', 'E', 'E'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Taş:1 sokaklarda:4 akşam:3' },
    { bar: 7, text: 'Bir:1 gitar:2 ağlar:2 uzakta:3' },
    { bar: 9, text: 'Avuçlar:3 vurur:2 ritmi:3' },
    { bar: 11, text: 'Topuklar:3 yere:2 dokunur:3' },
    { bar: 13, text: 'Sıcak:2 bir:1 rüzgâr:2 eser:3' },
    { bar: 15, text: 'Denizden:4 dağlara:4' },
    { bar: 17, text: 'Endülüs:2 rüzgârı,:2 dön:2 bana:2' },
    { bar: 19, text: 'Ateşini:3 getir:2 yine:3' },
    { bar: 21, text: 'Basamak:2 basamak:2 iner:4' },
    { bar: 23, text: 'Kalbim:2 de:2 ardından:4' },
  ],
});
